module.exports = __webpack_public_path__ + "img/twitter.aa30e1c.png";